// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* This need to be updated with PBX view. this classes are used in PBX view */

#content-wrapper.onlyRightNav #main-wrapper,
#content-wrapper.onlyRightNav .chat-area,
#content-wrapper.onlyRightNav .channel-chat-area {
    display: none;
}

#content-wrapper.onlyRightNav > #right-wrapper {
    flex-grow: 1;
}

#content-wrapper.onlyContent > #right-wrapper {
    display: none;
}
`, "",{"version":3,"sources":["webpack://./src/app/flow/route-components/css/ContentWrapper.css"],"names":[],"mappings":"AAAA,6EAA6E;;AAE7E;;;IAGI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB","sourcesContent":["/* This need to be updated with PBX view. this classes are used in PBX view */\n\n#content-wrapper.onlyRightNav #main-wrapper,\n#content-wrapper.onlyRightNav .chat-area,\n#content-wrapper.onlyRightNav .channel-chat-area {\n    display: none;\n}\n\n#content-wrapper.onlyRightNav > #right-wrapper {\n    flex-grow: 1;\n}\n\n#content-wrapper.onlyContent > #right-wrapper {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
